import { PresupuestoBadge } from "./PresupuestoBadge";
import { MoneyInput } from "./MoneyInput";

const TIPO_COLOR = { INGRESO: "#4ade80", GASTO: "#fbbf24" };

// Compartida con el header de la tabla en Presupuesto.js — NO cambiar sin
// actualizar ahí también, para que las columnas queden alineadas.
export const PRESUPUESTO_COLS = "480px repeat(12, 108px) 128px 140px";

export function PresupuestoNode({
  node, depth = 0, expandedIds, onToggle, edits, onEditMonth, calcularTotal, calcularMes, conReal,
}) {
  const expanded = expandedIds.has(node.id);
  const tieneHijos = node.subcuentas?.length > 0;
  const color = TIPO_COLOR[node.tipo] || TIPO_COLOR.INGRESO;
  const indent = depth * 18;
  const total = calcularTotal(node);

  const inputSt = {
    background: "rgba(255,255,255,0.06)", border: "1px solid var(--border-card)",
    borderRadius: 6, padding: "5px 6px", color: "#f1f5f9",
    fontSize: "0.78rem", outline: "none", width: "100%", boxSizing: "border-box", textAlign: "right",
  };

  // Celda mensual read-only para cuentas con hijas: muestra el subtotal en vivo
  // (propio + subárbol), alineado con los inputs de las hojas.
  const rollupCellSt = {
    padding: "5px 6px", fontSize: "0.78rem", width: "100%", boxSizing: "border-box",
    textAlign: "right", color: "var(--text-secondary)", fontWeight: 600,
    fontFamily: "monospace",
  };
  const fmtMes = (v) => Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div>
      <div style={{
        display: "grid", gridTemplateColumns: PRESUPUESTO_COLS, alignItems: "center",
        columnGap: 10, padding: "6px 10px",
        borderBottom: "1px solid var(--border-card)",
        background: depth === 0 ? "var(--hover-bg)" : "transparent",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, paddingLeft: indent, minWidth: 0 }}>
          <button type="button" onClick={() => onToggle(node.id)} disabled={!tieneHijos}
            style={{
              background: "none", border: "none",
              cursor: tieneHijos ? "pointer" : "default",
              color: tieneHijos ? "#f97316" : "transparent",
              width: 16, flexShrink: 0, fontSize: "0.66rem", padding: 0,
            }}>
            <i className={`fa-solid fa-chevron-${expanded ? "down" : "right"}`} />
          </button>

          <div style={{
            width: 6, height: 6, borderRadius: "50%", background: color, flexShrink: 0,
            opacity: node.is_detalle ? 1 : 0.4,
          }} />

          <span style={{
            fontFamily: "'JetBrains Mono','Courier New',monospace",
            fontSize: "0.68rem", color: "var(--text-muted)", flexShrink: 0,
          }}>
            {node.codigo}
          </span>

          <span style={{
            color: depth === 0 ? "var(--text-primary)" : "var(--text-secondary)",
            fontSize: depth === 0 ? "0.85rem" : "0.81rem",
            fontWeight: depth === 0 ? 700 : 400,
            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0,
          }} title={node.nombre}>
            {node.nombre}
          </span>
        </div>

        {[1,2,3,4,5,6,7,8,9,10,11,12].map(m => (
          tieneHijos ? (
            <div key={m} style={rollupCellSt} title="Subtotal automático (suma de las subcuentas)">
              {fmtMes(calcularMes(node, m))}
            </div>
          ) : (
            <MoneyInput key={m} style={inputSt}
              value={edits[`${node.id}-${m}`] ?? "0"}
              onChange={(v) => onEditMonth(node.id, m, v)} />
          )
        ))}

        <span style={{
          textAlign: "right", fontWeight: 700, color: "var(--text-primary)",
          fontSize: "0.82rem", fontFamily: "monospace",
        }}>
          {total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {conReal && <PresupuestoBadge estado={node.alerta} />}
        </div>
      </div>

      {expanded && node.subcuentas?.map(sub => (
        <PresupuestoNode
          key={sub.id} node={sub} depth={depth + 1}
          expandedIds={expandedIds} onToggle={onToggle}
          edits={edits} onEditMonth={onEditMonth}
          calcularTotal={calcularTotal} calcularMes={calcularMes} conReal={conReal}
        />
      ))}
    </div>
  );
}
